import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors, rt) => ({
  locationIcon: {
    width: 80,
    height: 80,
    borderRadius: 40,
    borderWidth: 1,
    borderColor: colors.borderSubtle,
    justifyContent: 'center',
    alignItems: 'center',
  },
  bottomSheet: {
    backgroundColor: colors.backgroundL0,
  },
  content: {
    backgroundColor: colors.backgroundL0,
    paddingBottom: rt.insets.bottom + theme.spacing[6],
  },
}));
